import React from 'react';
import { ArrowBack } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';

export const BackButton = ({ onClick, title = 'Back', disabled = false }) => (
  <Tooltip title={title}>
    <IconButton disabled={disabled} onClick={onClick} sx={{ mr: 2 }}>
      <ArrowBack />
    </IconButton>
  </Tooltip>
);
